import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function HelpAndFaq() {
  const [helpData, setHelpData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchHelpData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "help-centre",
        }
      );
      setHelpData(res.data.data);
    } catch (err) {
      console.error("Error help and faq:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
    fetchHelpData();
  }, []);

  return (
    <section class="ser_v_araeea faqess">
      <SetMetaTags
        title={helpData?.meta_title}
        description={helpData?.meta_description}
        keywords={helpData?.meta_keyword}
      />

      <div class="container">
        <div class="faq_contentss">
          {loading ? (
            <Skeleton count={5} height={20} style={{ marginBottom: "10px" }} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: helpData?.content }} />
          )}
        </div>
      </div>
    </section>
  );
}

export default HelpAndFaq;
